// extracted by mini-css-extract-plugin
export default {"labeled-value__label":"styles_labeled-value__label__SpqLx","labeled-value__value":"styles_labeled-value__value__h8bpb"};